// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__iABfV","content":"GlobalSearch_content__3Kjfr"};